import {create} from 'zustand';
import { persist } from "zustand/middleware";

// Interface pour les tokens
interface dataState {
    myPhoneNumber: string | null;
    currentEvents: [],
    myTickets: [],
    //currentService: [],
    setMyPhoneNumber: (myPhoneNumber: string) => void;
    setMyTickets: (currentEvents: []) => void;
    setCurrentEvents: (currentEvent: []) => void;
}


// Store Zustand pour la gestion des tokens
export const useDataStore = create<dataState>()(
    persist(
        (set) => ({
            myPhoneNumber: null,
            myTickets: [],
            currentEvents: [],

            setMyPhoneNumber: (myPhoneNumber: string) =>
                set({ myPhoneNumber }),

            setCurrentEvents: (currentEvents: []) =>
                set({ currentEvents }),

            setMyTickets: (myTickets: []) =>
                set({ myTickets }),

        }),
        {
            name: 'data-storage', // name of the item in the storage (must be unique)
        },
    ),
)

export default useDataStore;
